import { FeatureFlags } from "@hooks/useQueryFeatureFlags";
import { Benefit, BenefitGate } from "../data";

/**
 * Whether a benefit's availability gate is satisfied.
 *
 * `AxisPartner` is a section-scoping gate rather than an availability one —
 * which section a benefit belongs to is decided by `selectorCatalogBenefits`,
 * so it is always open here.
 */
export const selectorBenefitIsGateOpen = (params: {
  benefit: Benefit;
  featureFlags?: FeatureFlags;
  showMasterPolicy: boolean;
}): boolean => {
  switch (params.benefit.gate) {
    case BenefitGate.MeridioFlag:
      return !!params.featureFlags?.meridio;
    case BenefitGate.MasterPolicy:
      return params.showMasterPolicy;
    default:
      return true;
  }
};
